import script from "./AgreementScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreementScreen.vue?vue&type=script&setup=true&lang=js"

import "./AgreementScreen.vue?vue&type=style&index=0&id=0126367a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0126367a"]])

export default __exports__